<template>
    <div>
        <van-pull-refresh v-model="isHomeLoading" @refresh="onHomeRefresh"
                          pulling-text="Se puede actualizar desplegando..."
                          loosing-text="Se puede actualizar liberando..."
                          loading-text="En carga..."
        >
        <div class="audithome_wrap">
            <div class="audithome_head">
                <div class="audithome_hleft">Superapoyomax</div>
                <div class="audithome_hright">
                    <div class="audithome_hrimg" @click.stop="onHomeCenter">
                        <!--<img src="../../assets/img/audithome_icon01.png" />-->
                    </div>
                    <!--<div class="audithome_hrimg" @click.stop="onHomeMenus">
                        <img src="../../assets/img/audithome_icon02.png" />
                    </div>-->
                </div>
            </div>
            <div class="audithome_tps">
                <van-notice-bar scrollable text="Desde 2025 hasta el presente, los usuarios acumulados de Superapoyomax: 5 milliones de personas, y el monto del préstamo acumulado es de 10 billiones." />
            </div>
        </div>
        <template v-if="!account_status">
            <div id="kychome">
                <div class="audithome_cont">
                    <div class="audithome_cview">
                        <div class="auditpass_wrap">

                            <div class="mobhome_onewrap">
                                <div class="mobhome_twoview">
                                    <div class="mobhome_tview">
                                        <div class="kychome_slider_title">Monto del préstamo</div>
                                        <div class="eshoy_slider_cont mobhome_tview_slider">
                                            <div class="loan-content-box">
                                                <div class="moneybox">
                                                    $ <span id="money">{{ dealNumber(sliderValue) }}</span>
                                                </div>

                                                <div class="sliderbox_wrap">
                                                    <div class="sliderbox_left">
                                                        <div class="sliderbox_cimg">
                                                            <img class="eshoy_gold_small" src="../../assets/img/eshoy_gold_small.png" alt="">
                                                        </div>
                                                        <div class="sliderbox_ctext">
                                                            $<span>200</span>
                                                        </div>
                                                    </div>
                                                    <div class="sliderbox_middle">
                                                        <div class="sliderBox">

                                                            <van-slider
                                                                    v-model="sliderValue"
                                                                    :min="200"
                                                                    :max="20000"
                                                                    bar-height="6px"
                                                                    inactive-color="D8D8D8"
                                                            >
                                                            </van-slider>

                                                        </div>
                                                    </div>
                                                    <div class="sliderbox_right">
                                                        <div class="sliderbox_cimg">
                                                            <img class="eshoy_gold_more" src="../../assets/img/eshoy_gold_more.png" alt="">
                                                        </div>
                                                        <div class="sliderbox_ctext">
                                                            <div class="sliderbox_ctext_view">
                                                                $<span>20,000</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="kychome_slider_title_one">Plazo del préstamo</div>
                                            <div class="kychome_slider_title_two">91 días</div>

                                            <div class="eshoy_slider_btns">
                                                <!--<div class="eshoy_slider_btn_view animate__animated animate__infinite animate__pulse" @click="onHomeConfirm">-->
                                                <div class="eshoy_slider_btn_view" @click="onHomeConfirm">
                                                    <van-button round color="#19A95C" block style="height: 1.111111rem;">
                                                        <span style="font-weight: 500;">Solicitar el préstamo</span>
                                                    </van-button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <div id="audithome">
                <div class="audithome_cont">
                    <div class="audithome_cview">
                        <div class="auditpass_wrap">
                            <img class="auditpass_bgimg" src="../../assets/img/audithome_bgimg.png" />
                            <div class="auditpass_view">
                                <div class="auditpass_title">Aprobación de préstamo</div>
                                <div class="auditpass_desc">
                                    Enhorabuena, tu solicitud de préstamo ha sido aprobada. Ahora descarga App e inicia sesión para completar el último paso para recibir tu dinero hoy. ¡Venga!
                                </div>
                                <div class="auditpass_solid_view">
                                    <div class="auditpass_solid_left">
                                        <img src="../../assets/img/auditpass_left.png" />
                                    </div>
                                    <div class="auditpass_solid_middle">Cuenta regresiva</div>
                                    <div class="auditpass_solid_right">
                                        <img src="../../assets/img/auditpass_right.png" />
                                    </div>
                                </div>
                                <div class="auditpass_times">
                                    <van-count-down :time="time" :format="format">
                                        <template #default="timeData">
                                            <div class="zpan_hthr_times">
                                                <div class="zpan_hthr_titmes">
                                                    <span>{{ timeData.hours + timeData.days * 24 }}</span>
                                                </div>
                                                <div class="zpan_hthr_ditmes">:</div>
                                                <div class="zpan_hthr_titmes">
                                                    <span>{{ timeData.minutes }}</span>
                                                </div>
                                                <div class="zpan_hthr_ditmes">:</div>
                                                <div class="zpan_hthr_titmes">
                                                    <span>{{ timeData.seconds }}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </van-count-down>
                                </div>

                                <div class="auditpass_btns">
                                    <van-button round color="#19A95C" block style="height: 1.222222rem;" @click="onConfirm">
                                        <span style="font-weight: 500;">RECIBIR DINERO</span>
                                    </van-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>


        <div class="auditcommon_cont">
            <div class="auditcommon_one">
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon01.png" />
                </div>
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon02.png" />
                </div>
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon03.png" />
                </div>
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon06.png" />
                </div>
            </div>
            <div class="auditcommon_two">
                <!--<video
                        width="100%"
                        muted
                        loop
                        autoplay="autoplay"
                        controls
                        src="./video/test3.mov"
                ></video>-->
            </div>
            <div class="auditcommon_thr" style="margin-bottom: 44px;">
                <img src="../../assets/img/homefooter_icon05.jpg" />
            </div>
        </div>
        </van-pull-refresh>

        <van-popup v-model="menusShow" position="right" :style="{ width: '72.22%' }">
            <div class="menus_wrap">
                <div class="menus_head">
                    <img src="../../assets/img/menus/logo.png" />
                </div>

                <div class="menus_list">
                    <div class="menus_items" :class="meunsId == '1' ? 'menus_items_active' : ''" @click.stop="onCheckItem('1')">
                        <div class="menus_item">
                            <div class="menus_iicon">
                                <template v-if="meunsId == '1'">
                                    <img class="menus_iicon01" src="../../assets/img/menus/icon01_active.png" />
                                </template>
                                <template v-else>
                                    <img class="menus_iicon01" src="../../assets/img/menus/icon01.png" />
                                </template>
                            </div>
                            <div class="menus_itext">Sobre nosotros</div>
                        </div>
                    </div>
                    <div class="menus_items" :class="meunsId == '2' ? 'menus_items_active' : ''" @click.stop="onCheckItem('2')">
                        <div class="menus_item">
                            <div class="menus_iicon">
                                <template v-if="meunsId == '2'">
                                    <img class="menus_iicon02" src="../../assets/img/menus/icon02_active.png" />
                                </template>
                                <template v-else>
                                    <img class="menus_iicon02" src="../../assets/img/menus/icon02.png" />
                                </template>
                            </div>
                            <div class="menus_itext">Aviso de privacidad</div>
                        </div>
                    </div>
                    <div class="menus_items" :class="meunsId == '3' ? 'menus_items_active' : ''" @click.stop="onCheckItem('3')">
                        <div class="menus_item">
                            <div class="menus_iicon">
                                <template v-if="meunsId == '3'">
                                    <img class="menus_iicon03" src="../../assets/img/menus/icon03_active.png" />
                                </template>
                                <template v-else>
                                    <img class="menus_iicon03" src="../../assets/img/menus/icon03.png" />
                                </template>
                            </div>
                            <div class="menus_itext">Ayuda</div>
                        </div>
                    </div>
                    <div class="menus_items" :class="meunsId == '4' ? 'menus_items_active' : ''" @click.stop="onCheckItem('4')">
                        <div class="menus_item">
                            <div class="menus_iicon">
                                <template v-if="meunsId == '4'">
                                    <img class="menus_iicon04" src="../../assets/img/menus/icon04_active.png" />
                                </template>
                                <template v-else>
                                    <img class="menus_iicon04" src="../../assets/img/menus/icon04.png" />
                                </template>
                            </div>
                            <div class="menus_itext">Términos y condiciones</div>
                        </div>
                    </div>
                </div>

                <div class="menus_cview"></div>

                <div class="menus_footer" @click.stop="onCloseMeuns">
                    <div class="menus_ficon">
                        <img src="../../assets/img/menus/back.png" />
                    </div>
                    <div class="menus_ftext">Volver</div>
                </div>
            </div>
        </van-popup>


        <!--<div class="com_fc_down_wrap" v-if="homelook && homelook =='isopen'">
            <div class="com_fc_down">
                <div class="com_fc_dview">
                    <img src="../../assets/img/comf_appdload.png" alt="">
                    <div class="com_fc_dvclose" @click="onAppLoadClose"></div>
                </div>
            </div>
        </div>-->

        <van-popup v-model="loginshow" position="bottom" round>
            <div class="verifycode_wrap">
                <div class="verifycode_cont">
                    <div class="verifycode_tilte"></div>
                    <div class="verifycode_top">
                        <div class="verifycode_tleft">
                                <span>
                                    Iniciar sesión registrarse
                                </span>
                        </div>
                        <div class="verifycode_tright" @click="onCloseLogin">
                            <img src="@/assets/mobimg/verifycode_tright.png" alt="">
                        </div>
                    </div>

                    <div class="verifycode_form">
                        <div class="verifycode_items verifycode_items_scale-1px">
                            <div class="verifycode_item">
                                <div class="verifycode_ioneleft">+52</div>
                                <div class="verifycode_ioneright">
                                    <input type="number" @input="onMobile" v-model="mobile" placeholder="Ingresa tu celular" >
                                </div>
                            </div>
                        </div>
                        <div class="verifycode_items" :class="isWarn ? 'verifycode_iwarn_scale-1px' : 'verifycode_items_scale-1px'">
                            <div class="verifycode_item verifycode_itemtwo"> <!--verifycode_itemtwo-->
                                <div class="verifycode_itwoleft">
                                    <input type="number" v-model="smscode" placeholder="Ingresa OTP" >
                                </div>
                                <div class="verifycode_itworight" @click="verificationCode" :class="isSendcode ? 'active' : '' " >
                                    <button id="sendcode" :class="isSendcode ? 'active' : '' " :disabled="isSendcode">{{codeval}}</button>
                                </div>
                            </div>
                        </div>

                        <div class="verifycode_fwran_view">
                            <template v-if="isVerGoogtoken">
                                Realiza la verificación de seguridad
                            </template>
                            <template v-if="varSmscode">
                                Ingresa el código correcto
                            </template>
                        </div>
                    </div>

                    <div class="verifycode_google_wrap">
                        <!--style="transform: scale(0.87); -webkit-transform: scale(0.87); transform-origin: 0 0; -webkit-transform-origin: 0 0;"-->
                        <!---->
                        <div class="verifycode_google_cont" id="verifycode_google_cont">

                        </div>
                    </div>

                    <div class="verifycode_footer_btns">
                        <div class="verifycode_footer_btn">
                            <van-button round color="#00CA88" block @click="goLogin">
                                <span style="font-weight: bold;">Entregar</span>
                            </van-button>
                        </div>
                    </div>

                    <div class="verifycode_footer_xys">
                        <div class="verifycode_footer_xy">
                            Ver <span>acuerdo de privacidad</span> y <span>acuerdo de usuario</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>

        <van-tabbar v-model="tabactive" active-color="#19A95C" inactive-color="#999999" @change="onTabChange">
            <van-tabbar-item icon="wap-home">Inicio</van-tabbar-item>
            <van-tabbar-item icon="contact">Yo</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script type="text/javascript">
    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import axios from 'axios'

    import FingerprintJS from '@fingerprintjs/fingerprintjs';

    import { openEventReport } from '@/api/user'

    import { Toast } from 'vant';
    let apiHead = '';

    export default{
        data() {
            return {
                tabactive: 0,
                menusShow: false,
                isFalse: false,
                time: null,
                format: 'HH:mm:ss',
                changeNum: 50,
                sliderValue: 20000,
                meunsId: null,
                account_status: null,
                homelook: 'isopen',
                loginshow: false,
                nums: 60,
                codeval: 'Recibir OTP',
                isSendcode: false,
                isWarn: false,
                mobile: null,
                smscode: null,
                isHomeLoading: false,
                googleSucctoken: null,
                isVerGoogtoken: false,
                varSmscode: false,
            }
        },
        created() {
            var userAgent = navigator.userAgent;
            console.log(userAgent);

            if (window.requestIdleCallback) {
                requestIdleCallback(() => {
                    this.createFingerprint(userAgent);
                });
            } else {
                setTimeout(() => {
                    this.createFingerprint(userAgent);
                }, 500);
            }
        },
        mounted() {
            this.countDown();
            let login_token = window.localStorage.getItem('login_token');

            let account_status = window.localStorage.getItem('account_status');

            if(login_token && account_status == '1'){
                this.account_status = true
            } else {
                this.account_status = false
            }

            this.homeFirstLoan();

            let homelook = window.localStorage.getItem('homelook');

            if(homelook){
                this.homelook = 'isclose';
            }

        },
        methods: {
            createFingerprint(userAgent){
                let fbclid = '';

                if(this.getQueryString('fbclid')){
                    fbclid = this.getQueryString('fbclid')
                }

                FingerprintJS.load().then(fp => {
                    fp.get().then(result => {
                        console.log(result.visitorId);
                        //localStorage.setItem('browserId', result.visitorId);
                        if (!localStorage.getItem("adjust_id")) {
                            setTimeout(async () => {
                                await this.$adjust.waitForAttribution().then((attr) => {
                                    localStorage.setItem("adjust_id", attr.adid)
                                    let deviceType = this.checkDevice();
                                    this.openEventReport(attr.adid, fbclid, result.visitorId, deviceType, userAgent);
                                });
                            }, 10);
                        } else {
                            let deviceType = this.checkDevice();
                            let adjustId = localStorage.getItem("adjust_id");
                            this.openEventReport(adjustId, fbclid, result.visitorId, deviceType, userAgent);
                        }
                    });
                });
            },
            checkDevice() {
                let device_type = 'PC';
                const ua = navigator.userAgent;
                if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
                    device_type = 'iPhone'
                } else if (/Android/.test(ua)) {
                    device_type = 'Android'
                }

                return device_type;
            },
            onTabChange(item){
                console.log(item)
                if(item == 1){
                    this.$router.push({
                        path: '/loanpage/loginhome'
                    })

                    /*this.$router.push({
                        path: '/loanpage/usercenter'
                    })*/
                }
            },
            getQueryString(name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                }
                return null;
            },
            onHomeRefresh() {
                this.isHomeLoading = true;
                this.createFingerprint();
            },
            async openEventReport(adjustId, facebook_id, finger_code, deviceType, userAgent){
                console.log('上报接口请求')
                let time_zone = getTimezoneName();
                console.log(time_zone);
                loadingShow();
                let ip = await getUserIp()
                console.log(ip)

                let postData = {
                    fa_bo_id: facebook_id,
                    fi_ng_er: finger_code,
                    us_eve_na: 'jg_open',
                };

                let headerParams = {
                    'ad-justad-id': adjustId,
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                    'us-de-ty': deviceType,
                    'us-age-en': userAgent
                };

                loadingShow();
                openEventReport(postData, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    ...headerParams
                }).then(res => {
                    loadingHide()
                    this.isHomeLoading = false;
                    if(res.ci == 200){
                        console.log('上报成功')
                    } else {
                        Toast(res.ms)
                    }
                }, error => {
                    loadingHide();
                    this.isHomeLoading = false;
                })
            },
            gotoLogin() {
                console.log('登录')
                //this.loginshow = true;

                /*let _this = this;

                setTimeout(() => {
                    //
                    window.grecaptcha.render('verifycode_google_cont', {
                        'sitekey': '6LesI4QlAAAAAJuVTcvWAK0xS8bph2oH5kHsYLOn',
                        'theme': 'light',  //主题颜色，有light与dark两个值可选
                        'size': 'normal', //尺寸规则，有normal与compact两个值可选
                        'callback': _this.grecaptchaCallback, //验证成功回调
                        'expired-callback': _this.expiredCallback, //验证过期回调
                        'error-callback': _this.errorCallback, //验证错误回调
                    });

                }, 200);*/

                this.$router.push({
                    path: '/loanpage/loginhome'
                })
            },
            getHomeUrlParams() {
                let homeurl = window.location.href;
                let homeurlParamsStr = null;

                if(homeurl && homeurl.length){
                    let homeurlArr = [];
                    homeurlArr = homeurl.split('?');
                    console.log(homeurlArr)

                    if(homeurlArr.length == 2){
                        homeurlParamsStr = homeurlArr[1]

                        console.log(homeurlParamsStr)
                    }
                }

                return homeurlParamsStr;
            },
            onAppLoadClose() {
                console.log('1111')
                window.localStorage.setItem('homelook', 'isclose');
                this.homelook = 'isclose';
            },
            async homeFirstLoan() {
                let _this = this;

                let timezoneName = getTimezoneName(); //时区

                let request_time = new Date().getTime();

                //let ip = await getUserIp();
                let ip = '';

                console.log(timezoneName)
                console.log(ip)

                this.getUserLocation().then(res => {
                    console.log(res)
                    if(res){
                        if(res == 'noHTML5'){ //浏览器不支持使用HTML5
                            console.log(111)
                            _this.firstCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                        } else if(res.message && res.message == 'User denied Geolocation'){ //用户拒绝
                            console.log(res.message)
                            _this.firstCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                        } else if(res.coords){ //获取坐标
                            let latitude = res.coords.latitude;
                            let longitude = res.coords.longitude;
                            console.log(latitude)
                            console.log(longitude)
                            _this.firstCommonParams(timezoneName, request_time, ip, longitude, latitude)
                        } else {
                            _this.firstCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                        }
                    } else {
                        _this.firstCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                    }
                });
            },
            firstCommonParams(time_zone, request_time, ip, longitude, latitude){
                let login_token = window.localStorage.getItem('login_token');
                let params = {};
                if(login_token){
                    params = {
                        source: 'Superapoyo',
                        longitude: longitude,
                        latitude: latitude,
                        app_version_code: '59',
                        platform: 'h5',
                        request_time: request_time,
                        ip: ip,
                        time_zone: time_zone,
                        access_token: login_token,
                    }
                } else {
                    params = {
                        source: 'Superapoyo',
                        longitude: longitude,
                        latitude: latitude,
                        app_version_code: '59',
                        platform: 'h5',
                        request_time: request_time,
                        ip: ip,
                        time_zone: time_zone,
                        access_token: '',
                    }
                }
                // console.log(params)

                let postData = {
                    ...params,
                    event_name: 'clickH5Link'
                };

                console.log(postData)

                /*axios.post(apiHead + '/h5/v1/dot/record/firstLoan', postData).then(res => {
                    console.log(res)
                })*/


            },
            async getCommomParams() {
                let _this = this;

                let timezoneName = getTimezoneName(); //时区

                let request_time = new Date().getTime();

                let ip = await getUserIp();

                console.log(timezoneName)
                console.log(ip)

                this.getUserLocation().then(res => {
                    console.log(res)
                    if(res){
                        if(res == 'noHTML5'){ //浏览器不支持使用HTML5
                            console.log(111)
                            _this.infoCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                        } else if(res.message && res.message == 'User denied Geolocation'){ //用户拒绝
                            console.log(res.message)
                            _this.infoCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                        } else if(res.coords){ //获取坐标
                            let latitude = res.coords.latitude;
                            let longitude = res.coords.longitude;
                            console.log(latitude)
                            console.log(longitude)
                            _this.infoCommonParams(timezoneName, request_time, ip, longitude, latitude)
                        } else {
                            _this.infoCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                        }
                    } else {
                        _this.infoCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                    }
                });
            },
            is_https(){
                return 'https:' == location.protocol ? true: false;
            },
            getUserLocation() {
                let _this = this;
                const result = new Promise(function(resolve){
                    if (window.navigator.geolocation) {
                        if(_this.is_https()){
                            window.navigator.geolocation.getCurrentPosition((position) => {
                                console.log(position)
                                /*var longitude = position.coords.longitude;
                                var latitude = position.coords.latitude;*/
                                resolve(position)
                            }, (error) => {
                                console.log(error)
                                resolve(error)
                            })
                        } else {
                            resolve('noHTML5')
                        }

                    } else {
                        Toast('Su navegador no soporta el uso de HTML5 para obtener servicios de geolocalización');
                        //您的浏览器不支持使用HTML5来获取地理位置服务
                        resolve('noHTML5')
                    }
                });
                return result;
            },
            infoCommonParams(time_zone, request_time, ip, longitude, latitude){
                let login_token = window.localStorage.getItem('login_token');
                let params = {};
                if(login_token){
                    params = {
                        source: 'Superapoyo',
                        longitude: longitude,
                        latitude: latitude,
                        app_version_code: '59',
                        platform: 'h5',
                        request_time: request_time,
                        ip: ip,
                        time_zone: time_zone,
                        access_token: login_token,
                    }
                } else {
                    params = {
                        source: 'Superapoyo',
                        longitude: longitude,
                        latitude: latitude,
                        app_version_code: '59',
                        platform: 'h5',
                        request_time: request_time,
                        ip: ip,
                        time_zone: time_zone,
                        access_token: '',
                    }
                }
                // console.log(params)

                let postData = {
                    ...params
                };

                console.log(postData)

                //loadingShow();
                axios.post(apiHead + '/h5/v1/account/info/get', postData).then(res => {
                    console.log(res)
                    Toast.clear();
                    //loadingHide()
                    if(res.data.code == 0){
                        let useData = res.data.data;

                        let current_step = useData.current_step;

                        //let account_profile = useData.account_profile;

                        //let useaccount_profile = JSON.stringify(account_profile);

                        //window.localStorage.setItem('account_profile', useaccount_profile);

                        if(current_step == '1110'){

                            let account_status = '0'
                            let expire_time = null;
                            let regular_user = 0;
                            let invalid_days = 0;

                            let h5_audit_result = useData.h5_audit_result;

                            if(h5_audit_result){
                                account_status = h5_audit_result.audit_result;
                                expire_time = h5_audit_result.expire_time;
                                regular_user = h5_audit_result.regular_user;
                                invalid_days = h5_audit_result.invalid_days;
                            }

                            if(account_status == '1'){ //通过

                                window.localStorage.setItem('account_status', '1');

                                window.localStorage.setItem('expire_time', expire_time);

                            } else if(account_status == '2'){ //拒绝

                                window.localStorage.setItem('account_status', '2');

                                window.localStorage.setItem('invalid_days', invalid_days);

                            } else if(account_status == '0'){ //等待审核中

                                window.localStorage.setItem('account_status', '0');
                            }

                            let homeUrlParams = this.getHomeUrlParams();
                            setTimeout(() => {

                                if(regular_user == 1){ //正式订单用户
                                    window.location.href = './cuenta.html?' + homeUrlParams
                                } else {
                                    if(account_status == '0'){ //待审核
                                        window.location.href = './auditawait.html?' + homeUrlParams
                                    } else if(account_status == '1'){
                                        window.location.href = './auditpass.html?' + homeUrlParams
                                    } else if(account_status == '2'){
                                        window.location.href = './auditrejection.html?' + homeUrlParams
                                    }
                                }

                            }, 200)

                        } else {
                            let homeUrlParams = this.getHomeUrlParams();
                            if(current_step == '1004'){ //个人信息
                                window.location.href = './applyperson.html?' + homeUrlParams
                            } else if(current_step == '1001'){ //工作信息
                                window.location.href = './applywork.html?' + homeUrlParams
                            } else if(current_step == '1005'){ //身份证信息
                                window.location.href = './applyidcard.html?' + homeUrlParams
                            } else if(current_step == '1010'){ //绑定银行卡
                                window.location.href = './applybank.html?' + homeUrlParams
                            } else if(current_step == '1006'){ //活体
                                window.location.href = './livingverify.html?' + homeUrlParams
                            }
                        }

                    } else if(res.data.code == 400114) {
                        Toast('Token inválido')

                        window.localStorage.clear();
                        let homeUrlParams = this.getHomeUrlParams();
                        setTimeout(() => {
                            window.location.replace('./kychome.html?' + homeUrlParams)
                        }, 200);

                    } else {
                        Toast(res.data.message)
                    }
                })
            },
            onConfirm() {
                // let postData = {
                //   event_name: 'jumpGPDownload'
                // };
                //
                // axios.post(apiHead + '/h5/v1/dot/record/firstLoan', postData).then(res => {
                //   console.log(res)
                //   window.location.href = 'https://superapoyo.onelink.me/IBEC/a60wmz6z'
                // })

                this.jumpGPDownload();

            },

            async jumpGPDownload() {
                let _this = this;

                let timezoneName = getTimezoneName(); //时区

                let request_time = new Date().getTime();

                let ip = await getUserIp();

                console.log(timezoneName)
                console.log(ip)

                this.getUserLocation().then(res => {
                    console.log(res)
                    if(res){
                        if(res == 'noHTML5'){ //浏览器不支持使用HTML5
                            console.log(111)
                             _this.jumpGPCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                        } else if(res.message && res.message == 'User denied Geolocation'){ //用户拒绝
                            console.log(res.message)
                            _this.jumpGPCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                        } else if(res.coords){ //获取坐标
                            let latitude = res.coords.latitude;
                            let longitude = res.coords.longitude;
                            console.log(latitude)
                            console.log(longitude)
                            _this.jumpGPCommonParams(timezoneName, request_time, ip, longitude, latitude)
                        } else {
                            _this.jumpGPCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                        }
                    } else {
                        _this.jumpGPCommonParams(timezoneName, request_time, ip, '0.0', '0.0')
                    }
                });
            },
            jumpGPCommonParams(time_zone, request_time, ip, longitude, latitude){
                let login_token = window.localStorage.getItem('login_token');
                let params = {};
                if(login_token){
                    params = {
                        source: 'Superapoyo',
                        longitude: longitude,
                        latitude: latitude,
                        app_version_code: '59',
                        platform: 'h5',
                        request_time: request_time,
                        ip: ip,
                        time_zone: time_zone,
                        access_token: login_token,
                    }
                } else {
                    params = {
                        source: 'Superapoyo',
                        longitude: longitude,
                        latitude: latitude,
                        app_version_code: '59',
                        platform: 'h5',
                        request_time: request_time,
                        ip: ip,
                        time_zone: time_zone,
                        access_token: '',
                    }
                }
                // console.log(params)

                let postData = {
                    ...params,
                    event_name: 'jumpGPDownload'
                };

                console.log(postData)

                axios.post(apiHead + '/h5/v1/dot/record/firstLoan', postData).then(res => {
                    console.log(res)

                })


            },
            googleInfo(inLink, outLink) {
                let postData = {
                    inLink: inLink,
                    outLink: outLink,
                }

                axios.post(apiHead + '/gateway/ApiService/api/v3/h5/notoken/google/info', postData).then(res => {
                    console.log(res)
                    window.location.href = outLink;
                })

            },
            onHomeConfirm() {
                console.log('前往登录')
                let login_token = window.localStorage.getItem('login_token');
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    this.getCommomParams();
                } else { //未登录
                    console.log('未登录1111')
                    this.gotoLogin();
                }
            },
            onCloseMeuns() {
                this.menusShow = false;

                //let  duihuanData = window.localStorage.getItem('duihuanData');
            },
            onCheckItem(id){
                this.meunsId = id;
                if(id == '1'){
                    window.location.href = './empresa.html'
                } else if(id == '2'){
                    window.location.href = './privacidad.html'
                } else if(id == '3'){
                    window.location.href = '../customerService/CentroDeAyuda.html'
                } else if(id == '4'){
                    window.location.href = './provision.html'
                } else if(id == '5'){
                    window.location.href = './cuenta.html'
                }
            },
            onHomeMenus() {
                //this.menusShow = true;
            },
            countDown() { // 传入时间戳
                //const d = new Date('2023-07-6').getTime()
                let d = window.localStorage.getItem('expire_time');
                if(d && d != 0){
                    const now = new Date().getTime();
                    let timeStamp = d - now;

                    console.log(timeStamp)
                    this.time = timeStamp;
                }
            },
            dealNumber(num) {
                if (num != 0 && num) {
                    num = num + "";
                    let splitList = num.split(".");
                    //将整数部分拆解为单个数字的数组倒序，然后拼装为新的数组，每3位数字进行一次匹配
                    let intStrList = splitList[0]
                        .split("")
                        .reverse()
                        .join("")
                        .match(/(\d{1,3})/g);
                    //将匹配后的数组用，拼接，再拆解为单个数字的数组，反转为原先数组形式，拼接为完整数字
                    let intStr = intStrList.join(",").split("").reverse().join("");
                    return intStr;
                }
                return num;
            },
            onHomeCenter() {
                /*let login_token = window.localStorage.getItem('login_token');
                let homeUrlParams = this.getHomeUrlParams();
                if(login_token){
                    window.location.href = './cuenta.html?' + homeUrlParams
                } else {
                    window.location.href = './loginhome.html?' + homeUrlParams
                }*/
            },
            onMobile(){
                //console.log(this.mobile)
                let getmobile = this.mobile;

                let firstStr = getmobile.substr(0, 1);

                if(firstStr == 1){ //1开始 11位

                    if(getmobile.length > 11){
                        this.mobile = getmobile.substr(0, 11);
                    }

                } else {//非1 10位
                    if(getmobile.length > 10){
                        this.mobile = getmobile.substr(0, 10);
                    }
                }
            },
            onCloseLogin() {
                this.loginshow = false;
            },
            verificationCode() {
                //let _this = this;

                //5213311111112
                // Toast.loading({
                //     message: '请求中...',
                //     forbidClick: true,
                // });

                if(this.mobile){
                    //console.log(111111)
                    let getmobile = this.mobile;

                    let firstStr = getmobile.substr(0, 1);

                    let isflag = false;

                    if(firstStr == 1){ //1开始 11位
                        if(getmobile.length == 11){
                            isflag = true;
                        } else {
                            isflag = false;
                        }

                    } else {//非1 10位
                        if(getmobile.length == 10){
                            isflag = true;
                        } else {
                            isflag = false;
                        }
                    }

                    if(isflag){

                        // if(this.googleSucctoken){
                            /*let usemobile = `+52${this.mobile}`;
                            let postData = {
                                "mobile": usemobile,
                                "source":"Rapidayuda",
                                "channel":"h501"
                            };
                            loadingShow();
                            getSmscode(postData).then(res => {
                                //console.log(res)
                                Toast.clear();
                                loadingHide()
                                if(res.code == 0){
                                    _this.isWarn = false;
                                    _this.varSmscode = false;
                                    _this.isSendcode = true;
                                    _this.codeval = this.nums + 's';
                                    clock = setInterval(_this.doLoop, 1000);
                                } else {
                                    _this.isWarn = true;
                                    _this.varSmscode = true;
                                    Toast(res.message)
                                }
                            }, error => {
                                _this.isWarn = true;
                                _this.varSmscode = true;
                                loadingHide()
                            });
                            this.isWarn = false;
                            this.isVerGoogtoken = false;*/
                        /*} else {
                            this.isWarn = true;
                            this.isVerGoogtoken = true;
                        }*/

                    } else {
                        //loadingHide()
                        Toast('Formato incorrecto del número móvil') //手机号码格式错误
                    }

                } else {
                    //loadingHide()
                    Toast('Por favor ingrese el número de teléfono móvil') //请输入手机号
                }
            },
            goLogin() {
                //let _this = this;
                this.isWarn = false;
                this.varSmscode = false;
                if(this.mobile){
                    let getmobile = this.mobile;

                    let firstStr = getmobile.substr(0, 1);

                    let isflag = false;

                    if(firstStr == 1){ //1开始 11位
                        if(getmobile.length == 11){
                            isflag = true;
                        } else {
                            isflag = false;
                        }

                    } else {//非1 10位
                        if(getmobile.length == 10){
                            isflag = true;
                        } else {
                            isflag = false;
                        }
                    }

                    //console.log(firstStr)

                    if(isflag){
                        //let usemobile = `+52${this.mobile}`;
                        //let usemobile = '+5213311111113';

                        /*if(this.smscode){
                            //this.googleSucctoken = true;
                            if(this.googleSucctoken){
                                Toast.loading({
                                    message: '请求中...',
                                    forbidClick: true,
                                });
                                //loadingShow()
                                /*let postData = {
                                    "mobile": usemobile,
                                    "source":"Rapidayuda",
                                    "channel":"h501",
                                    "auth_code": _this.smscode
                                };
                                loginsms(postData).then(res => {
                                    //loadingHide()
                                    if(res.code == 0){
                                        //console.log(res)
                                        let useData = res.data;

                                        if(useData){
                                            let access_token = useData.access_token;
                                            setAccessToken(access_token);

                                            let is_repeat_loan = useData.is_repeat_loan;
                                            setIsRepeatLoan(is_repeat_loan);

                                            _this.$store.commit('common/SET_PAGE_TYPE', 'h501');

                                            _this.getloanInfo(access_token, is_repeat_loan);

                                            /!*if(is_repeat_loan){ //复贷
                                                _this.$router.push({
                                                    path: '/compoundloan/indextoken'
                                                })
                                            } else {
                                                console.log('首贷用户')
                                                _this.$router.push({
                                                    path: '/compoundloan/indexnew'
                                                })
                                            }*!/
                                        } else {
                                            loadingHide()
                                        }

                                    } else {
                                        loadingHide()
                                        Toast(res.message)
                                    }
                                }, error => {
                                    if(error.code == 400116){
                                        _this.isWarn = true;
                                        _this.varSmscode = true;
                                    }
                                    loadingHide()
                                })*/


                           /* } else {
                                Toast('Por favor marque la verificación humana') //请勾选人机验证
                            }
                        } else {
                            Toast('Por favor introduzca el captcha') //请输入验证码
                        } */



                    } else {
                        Toast('Formato incorrecto del número móvil') //手机号码格式错误
                    }

                } else {
                    Toast('Por favor ingrese el número de teléfono móvil') //请输入手机号
                }
            }
        }
    }

</script>

<style scss scoped>
    .audithome_wrap{
        width: 100%;
        height: 9.861111rem;
        background: linear-gradient(180deg, #19A95C 0%, #F6F6F6 100%);
    }
    .audithome_head{
        width: 100%;
        height: 1.333333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 0.444444rem;
    }
    .audithome_hleft{
        width: 5.555556rem;
        height: 0.583333rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #FFFFFF;
    }
    .audithome_hright{
        width: 1.361111rem;
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
    }
    .audithome_hrimg{
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_hrimg img{
        display: block;
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_tps{
        width: 100%;
        height: 0.833333rem;
        box-sizing: border-box;
        /*padding: 0 0.444444rem;*/
        background: rgba(255,255,255,0.26);
        /*display: flex;*/
        /*justify-content: flex-start;*/
        /*align-items: center;*/
    }
    .audithome_tps span{
        width: 100%;
        height: 0.388889rem;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        transform: scale(0.9);
        transform-origin:0 0;
        overflow: hidden;
        white-space:nowrap;
        -o-text-overflow:ellipsis;
        text-overflow:ellipsis;
    }
    #kychome{
        /*padding-bottom: 30px;*/
    }
    #kychome .audithome_cont{
        width: 100%;
        height: 0.833333rem;
        position: relative;
    }
    #kychome  .audithome_cview{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: -7.694444rem;
    }
    #kychome  .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    #kychome .auditpass_bgimg{
        display: block;
        width: 100%;
    }
    #kychome .audithome_cont .auditpass_view{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 4.222222rem;
    }
    #kychome .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    #kychome .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    #kychome .auditpass_solid_view{
        width: 100%;
        height: 0.388889rem;
        margin-top: 4.25rem;
        box-sizing: border-box;
        padding: 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    #kychome .auditpass_solid_middle{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #19A95C;
        line-height: 0.388889rem;
    }
    #kychome .auditpass_solid_left{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #kychome .auditpass_solid_left img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #kychome .auditpass_solid_right{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #kychome .auditpass_solid_right img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #kychome .auditpass_times{
        width: 100%;
        height: 1.611111rem;
        box-sizing: border-box;
        padding-top: 0.222222rem;
    }
    #kychome .zpan_hthr_times{
        width: 28.4%;
        height: 0.694444rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    #kychome .zpan_hthr_titmes{
        width: 0.694444rem;
        height: 0.694444rem;
        background: #ffffff;
        border-radius: 0.083333rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #BCDCCA;
    }
    #kychome .zpan_hthr_titmes span{
        font-size: 0.388889rem;
        font-weight: 600;
        color: #19A95C;
    }
    #kychome .zpan_hthr_ditmes{
        width: 0.388889rem;
        height: 0.583333rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #kychome .auditpass_btns{
        width: 92.22%;
        height: 1.222222rem;
        margin: 0 auto;
    }
    .auditcommon_cont{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.833333rem 0.416667rem;
    }
    .auditcommon_one{
        width: 100%;
        height: 4.166667rem;
    }
    .auditcommon_oitem{
        width: 50%;
        height: 2.083333rem;
        float: left;
    }
    .auditcommon_oitem img{
        display: block;
        width: 100%;
        height: 2.083333rem;
    }
    .auditcommon_two{
        width: 100%;
        height: auto;
        border-radius: 6px;
        margin: 0.416667rem 0;
        overflow: hidden;
    }
    /*.auditcommon_two video{*/
    /*width: 100%;*/
    /*height: 4.444444rem;*/
    /*}*/
    .auditcommon_thr{
        width: 100%;
        height: auto;
    }
    .auditcommon_thr img{
        display: block;
        width: 100%;
    }

    .mobhome_onewrap{
        width: 100%;
        height: auto;
        padding-top: 0.277778rem;
    }
    .mobhome_twoview{
        width: 91.11%;
        height: 8.666667rem;
        margin: 0 auto;
        background: #ffffff;
        box-sizing: border-box;
        padding: 0.277778rem;
        border-radius: 0.222222rem;
    }
    .mobhome_tview{
        width: 100%;
        height: 100%;
        border-radius: 0.222222rem;
        border: 1px solid rgba(25,169,92,0.21);
        filter: blur(0px);

    }
    .mobhome_thrview{
        width: 100%;
        height: 0.916667rem;
        margin: 11px auto 0 auto;
    }
    .mobhome_thrview img{
        width: 43.47%;
        display: block;
        margin: 0 auto;
    }
    .mobhome_fivborder{
        width: 88.89%;
        padding-top: 1.916667rem;
        margin: 0 auto;
    }
    .mobfooter_wrap{
        width: 100%;
        height: auto;
        background: #0A0B0E;
        padding-top: 1.944444rem;
        padding-bottom: 1.944444rem;
    }
    .mobfooter_cont{
        width: 88.89%;
        height: auto;
        margin: 0 auto;
    }
    .mobfooter_title{
        width: 100%;
        height: 0.444444rem;
        font-size: 0.444444rem;
        font-weight: 600;
        color: #E8E8E9;
        line-height: 0.444444rem;
    }
    .mobfooter_list{
        width: 100%;
        height: auto;
        padding-top: 0.333333rem;
    }
    .mobfooter_items{
        width: 100%;
        height: 1.5rem;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
    }
    .mobfooter_ileft{
        width: auto;
        height: 1.5rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #E8E8E9;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .mobfooter_ileft_active{
        color: #39CA80;
    }
    .mobfooter_iright{
        width: 0.277778rem;
        height: 1.5rem;
        display: flex;
        align-items: center;
    }
    .mobfooter_iright img{
        display: block;
        width: 100%;
        height: 0.416667rem;
    }
    .mobfooter_middle{
        width: 100%;
        height: auto;
        padding-top: 1.388889rem;
    }
    .mobfooter_mimg{
        width: 100%;
        padding-top: 0.611111rem;
    }
    .mobfooter_mimg img{
        display: block;
        width: 4.861111rem;
    }
    .mobfooter_down{
        width: 100%;
        padding-top: 1.388889rem;
    }
    .mobfooter_dlist{
        width: 100%;
        height: auto;
        padding-top: 0.333333rem;
    }
    .mobfooter_dlitem{
        width: 100%;
        height: auto;
        padding-top: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #B6B8BF;
    }
    .mobhome_tview .eshoy_slider_cont{
        width: 100%;
        background: none;
    }
    .mobhome_tview .sliderbox_wrap{
        width: 87.5%;
        margin: 0 auto;
    }
    .mobhome_tview .sliderbox_left{
        width: 16.3%;
        height: 1.194444rem;
        padding-top: 1px;
    }
    .mobhome_tview .sliderbox_middle{
        width: 66%;
    }
    .mobhome_tview .sliderbox_right{
        width: 16.3%;
        height: 1.194444rem;
        padding-top: 1px;
    }
    .mobhome_tview .sliderbox_cimg{
        width: 100%;
        height: 0.694444rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .mobhome_tview .eshoy_gold_small{
        display: block;
        width: 24px;
        height: 14px;
    }
    .mobhome_tview .eshoy_gold_more{
        display: block;
        width: 24px;
        height: 21px;
    }
    .mobhome_tview .sliderbox_ctext{
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.37rem;
        margin-top: 2px;
        position: relative;
    }
    .sliderbox_ctext_view{
        width: auto;
        height: 0.5rem;
        position: absolute;
        left: -0.22rem;
        top: 0;
    }
    .mobhome_tview .sliderBox{
        width: 100%;
    }
    .mobhome_tview .moneybox{
        height: 1.138889rem;
        font-size: 0.833333rem;
        padding-bottom: 0.527778rem
    }
    .mobhome_tview .moneybox span {
        font-size: 0.944444rem;
    }
    .mobhome_tview .sliderBox{
        margin: 0.35rem auto 0 auto;
    }
    .mobhome_tview .el-slider__bar{
        height: 0.138889rem !important;
        border-radius: 0.069444rem !important;
    }
    .mobhome_tview .el-slider__runway{
        height: 0.138889rem !important;
        border-radius: 0.069444rem !important;
    }
    .mobhome_tview .el-slider__button-wrapper{
        width: 0.972222rem !important;
        height: 0.972222rem !important;
        top: -0.388889rem !important;
    }
    .mobhome_tview .sliderbox_wrap{
        height: 1.694444rem;
    }
    .mobhome_tview .eshoy_slider_btns{
        width: 7.722222rem;
        height: 1.111111rem;
        margin-top: 0;
    }
    .mobhome_tview .eshoy_slider_btn_view{
        width: 7.722222rem;
        height: 1.111111rem;
    }

    .moneybox {
        font-size: 0.833333rem;
        font-weight: 600;
        color: #333333;
        text-align: center;
        text-align: center;
        padding-bottom: 74px;
    }

    .moneybox span {
        font-size: 1.0rem;
    }

    .sliderBox {
        width: 546px;
        height: auto;
        background: #E4EFEB;
        border-radius: 5px;
        margin: 24px auto 0 auto;
        position: relative;
    }

    .range {
        display: none;
        justify-content: space-between;
        margin-top: 35px;
    }

    .range p {
        font-size: 16px;
        color: #666;
        font-weight: 500;
    }

    .range p span {
        font-size: 18px;
    }
    .sliderbox_wrap{
        width: 762px;
        height: 86px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    .sliderbox_left{
        width: 88px;
        height: 86px;
    }

    .sliderbox_right{
        width: 88px;
        height: 86px;
    }
    .sliderbox_cimg{
        width: 88px;
        height: 50px;
    }
    .sliderbox_ctext{
        width: 100%;
        height: 36px;
        font-size: 18px;
        font-family: MiSans-Regular, MiSans;
        font-weight: 500;
        color: #8C8480;
        line-height: 36px;
        text-align: center;
    }
    .sliderbox_ctext span{
        padding-left: 6px;
    }
    .eshoy_slider_btns{
        width: 378px;
        height: 72px;
        margin: 80px auto 0 auto;
        cursor: pointer;
    }
    .eshoy_slider_btn_view{
        width: 378px;
        height: 72px;
    }
    .eshoy_slider_btns img{
        display: block;
        width: 100%;
    }
    .kychome_slider_title{
        width: 100%;
        height: 1.083333rem;
        font-size: 0.444444rem;
        font-weight: 400;
        color: #666666;
        line-height: 1.083333rem;
        text-align: center;
    }
    .kychome_slider_title_one{
        width: 100%;
        height: 0.805556rem;
        font-size: 0.444444rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.527778rem;
        text-align: center;
    }
    .kychome_slider_title_two{
        width: 100%;
        height: 1.0rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    .menus_wrap{
        width: 100%;
        height: 100vh;
        position: relative;
    }
    .menus_head{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.833333rem 0 1.055556rem 0.694444rem;
    }
    .menus_head img{
        display: block;
        width: 1.388889rem;
        height: 1.388889rem;
    }
    .menus_footer{
        width: 100%;
        height: 2.2rem;
        background: #F6F6F6;
        border-radius: 0px 0px 0px 0.555556rem;
        position: absolute;
        left: 0;
        bottom: 0;
        box-sizing: border-box;
        padding: 0.555556rem 0 0 0.694444rem;
        display: flex;
        justify-content: flex-start;
    }
    .menus_ficon{
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_ficon img{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_ftext{
        width: 1.388889rem;
        height: 0.555556rem;
        margin-left: 0.361111rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #666666;
        line-height: 0.555556rem;
    }
    .menus_list{
        width: 100%;
        height: auto;
    }
    .menus_items{
        width: 100%;
        height: 1.305556rem;
    }
    .menus_item{
        width: 100%;
        height: 1.111111rem;
        box-sizing: border-box;
        padding-left: 0.694444rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .menus_iicon{
        width: 0.916667rem;
        height: 0.555556rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding-right: 0.361111rem;
    }
    .menus_iicon01{
        display: block;
        width: 0.555556rem;
        height: 0.5rem;
    }
    .menus_iicon02{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_iicon03{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_iicon04{
        display: block;
        width: 0.5rem;
        height: 0.555556rem;
    }
    .menus_itext{
        width: auto;
        height: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.555556rem;
    }
    .menus_cview{
        width: 100%;
        height: 1.861111rem;
    }
    .menus_items_active .menus_item{
        background: #19A95C;
    }
    .menus_items_active .menus_itext{
        color: #FFFFFF;
    }

    #audithome .audithome_cont{
        width: 100%;
        height: 6.861111rem;
        position: relative;
    }
    #audithome .audithome_cview{
        width: 100%;
        height: 14.555556rem;
        position: absolute;
        left: 0;
        top: -7.694444rem;
    }
    #audithome .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    #audithome .auditpass_bgimg{
        display: block;
        width: 100%;
    }
    #audithome .audithome_cont .auditpass_view{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 4.222222rem;
    }
    #audithome .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    #audithome .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    #audithome .auditpass_solid_view{
        width: 100%;
        height: 0.388889rem;
        margin-top: 4.25rem;
        box-sizing: border-box;
        padding: 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    #audithome .auditpass_solid_middle{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #19A95C;
        line-height: 0.388889rem;
    }
    #audithome .auditpass_solid_left{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #audithome .auditpass_solid_left img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #audithome .auditpass_solid_right{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #audithome .auditpass_solid_right img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #audithome .auditpass_times{
        width: 100%;
        height: 1.611111rem;
        box-sizing: border-box;
        padding-top: 0.222222rem;
    }
    #audithome .zpan_hthr_times{
        width: 28.4%;
        height: 0.694444rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    #audithome .zpan_hthr_titmes{
        width: 0.694444rem;
        height: 0.694444rem;
        background: #ffffff;
        border-radius: 0.083333rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #BCDCCA;
    }
    #audithome .zpan_hthr_titmes span{
        font-size: 0.388889rem;
        font-weight: 600;
        color: #19A95C;
    }
    #audithome .zpan_hthr_ditmes{
        width: 0.388889rem;
        height: 0.583333rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #audithome .auditpass_btns{
        width: 92.22%;
        height: 1.222222rem;
        margin: 0 auto;
    }
    #audithome{
        padding-bottom: 30px;
    }
    .com_fc_down_wrap{
        width: 100%;
        height: 1.666667rem;
    }
    .com_fc_down{
        width: 100%;
        height: auto;
        position: fixed;
        left: 0;
        bottom: 0.444444rem;
    }
    .com_fc_dview{
        width: 100%;
        height: 1.666667rem;
        margin: 0 auto;
        position: relative;
    }
    .com_fc_dview img{
        display: block;
        width: 100%;
        height: 100%;
    }
    .com_fc_dvclose{
        width: 1.666667rem;
        height: 1.666667rem;
        position: absolute;
        top: 0;
        right: 0;
    }
    .verifycode_wrap{
        width: 100%;
        height: auto;
    }
    .verifycode_cont{
        width: 100%;
        height: auto;
        background: #FFFFFF;
        border-radius: 0.555556rem 0.555556rem 0px 0px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 0.222222rem;
    }
    .verifycode_tilte{
        width: 1.25rem;
        height: 0.083333rem;
        background: #CFCFCF;
        border-radius: 0.083333rem;
        margin: 0 auto;
    }
    .verifycode_top{
        width: 100%;
        height: 2.583333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.555556rem 0.444444rem 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    .verifycode_tleft{
        width: auto;
        height: 0.611111rem;
        font-size: 0.527778rem;
        font-weight: bold;
        color: #1A1A1A;
        line-height: 44px;
        display: flex;
        align-items: center;
    }
    .verifycode_tleft span{
        float: left
    }
    .verifycode_tright{
        width: 0.666667rem;
        height: 0.666667rem;
    }
    .verifycode_tright img{
        display: block;
        width: 100%;
    }
    .verifycode_form{
        width: 91.11%;
        height: 5.972222rem;
        margin: 0 auto;
    }
    .verifycode_items_scale-1px{
        position: relative;
        border:none;
    }
    .verifycode_items_scale-1px:after{
        content: '';
        position: absolute;
        bottom: 0;
        background: #E7E7E7;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .verifycode_items{
        width: 100%;
        height: 1.444444rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 0.277778rem;
    }
    .verifycode_item{
        width: 100%;
        height: 1.166667rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .verifycode_ioneleft{
        width: 1.055556rem;
        height: 1.166667rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #1A1A1A;
        line-height: 1.166667rem;
    }
    .verifycode_ioneright{
        width: 7.777778rem;
        height: 1.166667rem;
    }
    .verifycode_ioneright input{
        display: block;
        width: 100%;
        height: 1.12rem;
        outline: none;
        border: none;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #1A1A1A;
        background: #ffffff;
        padding: 0;
    }
    .verifycode_itemtwo{
        justify-content: space-between;
    }
    .verifycode_itwoleft{
        width: 4.0rem;
        height: 1.166667rem;
    }
    .verifycode_itwoleft input{
        display: block;
        width: 100%;
        height: 1.1rem;
        outline: none;
        border: none;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #1A1A1A;
        background: #ffffff;
        padding-left: 0;
    }
    .verifycode_itworight{
        width: auto;
        height: 0.75rem;
        background: #00CA88;
        border-radius: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        padding: 0 0.13rem;
    }
    .verifycode_itworight.active{
        background: #CFCFCF;
    }
    .verifycode_itworight #sendcode{
        width: auto;
        min-width: 2.4rem;
        display: block;
        height: auto;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        outline: none;
        border: none;
        margin: 0 auto;
        background: #00CA88;
    }
    .verifycode_itworight #sendcode.active{
        background: #CFCFCF;
    }
    .verifycode_iwarn_scale-1px{
        position: relative;
        border:none;
    }
    .verifycode_iwarn_scale-1px:after{
        content: '';
        position: absolute;
        bottom: 0;
        background: #DB861F;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .verifycode_fwran_view{
        width: 100%;
        height: auto;
        padding-top: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #DB861F;
    }
    .verifycode_google_wrap{
        width: 100%;
        height: 2.388889rem;
        display: flex;
        justify-content: center;
    }
    .verifycode_google_cont{
        width: 7.305556rem;
        height: 1.944444rem;
        margin: 0 auto;
    }
    .verifycode_footer_btns{
        width: 100%;
        height: 1.666667rem;
    }
    .verifycode_footer_btn{
        width: 91.11%;
        height: 1.222222rem;
        margin: auto;
    }
    .verifycode_footer_xys{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        padding-bottom: 0.555556rem;
    }
    .verifycode_footer_xy{
        font-size: 14px;
        transform: scale(0.79);
        font-weight: 400;
        color: #00CA88;
    }
    .verifycode_footer_xy span{
        text-decoration: underline;
    }
</style>

<style less>
    .hide{
        display: none!important;
    }
    .potato_loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999999;
    }
    .potato_loading_zhe{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(0,0,0,0.6);
        opacity: 0;
        transition: opacity 0.4s ease;
    }
    .potato_loading_zhe_tr{
        opacity: 1!important;
    }
    .potato_loading1{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 0.4s ease;
    }
    .potato_loading1_Icon {
        width: 40px;
        height: 40px;
        margin: 0;
        background: transparent;
        border-top: 3px solid #9FB5DE;
        border-right: 3px solid transparent;
        border-radius: 50%;
        -webkit-animation: 1s spin linear infinite;
        animation: 1s spin linear infinite;
    }
    .potato_loading1_title{
        font-size: 14px;
        color: #9FB5DE;
    }
    .potato_loading3_title{
        display: inline-block;
        padding: 10px 14px;
        border-radius: 10px;
        background-color: rgba(0,0,0,0.8);
        color: #fff;
        max-width: 80%;
        line-height: 0.44rem;
    }
    @keyframes spin{
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    input::-webkit-input-placeholder {
        /* WebKit browsers，webkit内核浏览器 */
        color: #CFCFCF;
        font-size: 12px;
    }
    input:-moz-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }
    input::-moz-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }
    input:-ms-input-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }

    .audithome_tps .van-notice-bar{
        height: 0.833333rem;
        background-color: rgba(0,0,0,0);
        color: #FFFFFF;
    }
    .van-slider__bar{
        background: linear-gradient(353deg, #19A95C 0%, #3DE189 100%);
    }
    .van-slider__button{
        width: 25px !important;
        height: 25px !important;
        background: url(../../assets/img/sliderBtn.png) top center no-repeat;
        background-size: cover;
        cursor: pointer;
        border: none !important;
        background-color: transparent !important;
        top: -27px !important;
    }
    .van-popup--right{
        border-radius: 0.555556rem 0px 0px 0.555556rem;
    }
</style>

